<app-main-content mode="1col">
  @if (userService.isAuthorized$('PZ_MAKLER') | async) {
    <app-infotext [willkommenstext]="'offert'"></app-infotext>
  }

  <mat-expansion-panel (opened)="isFilterOpen = true" (closed)="isFilterOpen = false" [@.disabled]="true"
                       class="filter-panel">
    <mat-expansion-panel-header expandedHeight="40px" collapsedHeight="40px">
      Filter&nbsp;
      <mat-icon class="mat-24">filter_list</mat-icon>
    </mat-expansion-panel-header>

    <ng-container *ngIf="selectedKunde">
      <mat-checkbox class="kunde-filter" [(ngModel)]="filterBySelectedPerson"
                    (change)="filterBySelectedPersonChanged()">
        Nur für aktuellen Kunden
        <b>{{ selectedKunde?.vorname?.value }} {{ selectedKunde?.name?.value }}</b>
      </mat-checkbox>
      <!--<app-spacer></app-spacer>-->
    </ng-container>
    <app-filter-search [allDataSources]="allDataSources" (afterFilter)="emitFilterChanged($event)"></app-filter-search>
  </mat-expansion-panel>
  <mat-tab-group #tabGroup [ngClass]="{'filter-active': isFilterOpen, 'kunde-selected': !!selectedKunde}"
                 [@.disabled]="true">
    <mat-tab [id]="ActiveTab.OfferteAntraege_OFFERTE">
      <ng-template mat-tab-label>
        <span>Offerte</span>
        <span *ngIf="offertDataSource.loading" class="matTabRightText">
          <ng-container *ngTemplateOutlet="tabLabelSpinner"></ng-container>
        </span>
        <span *ngIf="!offertDataSource.loading" class="matTabRightText">
          ({{ offertDataSource.dataSource.filteredData.length / 2 }})
        </span>
      </ng-template>
      <ng-template matTabContent>
        <app-offertstageone [listData]="offertDataSource" [iddBefreit]="iddBefreit" class="flex-container-column"
                            [filterChangedEvent]="filterChangedSubject.asObservable()"
                            [markedPolintSubject]="markedPolintSubject"></app-offertstageone>
      </ng-template>
    </mat-tab>
    @if (userService.isAuthorized$(listDataConfig.BERATUNG_EMPFEHLUNG.right) | async) {
      <mat-tab [id]="ActiveTab.OfferteAntraege_BEREMPF">
        <ng-template mat-tab-label>
        <span>
          {{ userTextService.getOffertStage2Bezeichnung$() | async }}
        </span>
          <span *ngIf="beratungEmpfehlungDataSource.loading" class="matTabRightText">
          <ng-container *ngTemplateOutlet="tabLabelSpinner"></ng-container>
        </span>
          <!-- Hier durch 3 (3 rows!) -->
          <span *ngIf="!beratungEmpfehlungDataSource.loading" class="matTabRightText">
          ({{ beratungEmpfehlungDataSource.dataSource.filteredData.length / (iddBefreit ? 2 : 3) }})
        </span>
        </ng-template>
        <ng-template matTabContent>
          <app-offertstagetwo [listData]="beratungEmpfehlungDataSource" [iddBefreit]="iddBefreit"
                              class="flex-container-column" [filterChangedEvent]="filterChangedSubject.asObservable()"
                              [markedPolintSubject]="markedPolintSubject"></app-offertstagetwo>
        </ng-template>
      </mat-tab>
    }
    @if (userService.isAuthorized$(listDataConfig.ANTRAG.right) | async) {
      <mat-tab [id]="ActiveTab.OfferteAntraege_ANTRAEGE">
        <ng-template mat-tab-label>
          <span>Anträge</span>
          <span *ngIf="antragDataSource.loading" class="matTabRightText">
          <ng-container *ngTemplateOutlet="tabLabelSpinner"></ng-container>
        </span>
          <span *ngIf="!antragDataSource.loading"
                class="matTabRightText">({{ antragDataSource.dataSource.filteredData.length / 2 }})</span>
        </ng-template>
        <ng-template matTabContent>
          <app-antraege [listData]="antragDataSource" class="flex-container-column"
                        [filterChangedEvent]="filterChangedSubject.asObservable()">
          </app-antraege>
        </ng-template>
      </mat-tab>
    }
    <!-- nicht freigegebene Anträge (externer Makler) -->
    @if (userService.isAuthorized$(listDataConfig.NICHT_FREIGEGEBENE_MAKLER_ANTRAEGE.right) | async) {
      <mat-tab [id]="ActiveTab.OfferteAntraege_NichtFreigegebeneAntraege">
        <ng-template mat-tab-label>
          <span>nicht freigegebene Anträge</span>
          <span class="matTabRightText">
          @if (nichtFreigegebeneMaklerAntraegeDataSource.loading) {
            <ng-container *ngTemplateOutlet="tabLabelSpinner"></ng-container>
          } @else {
            ({{ nichtFreigegebeneMaklerAntraegeDataSource.dataSource.filteredData.length / 3 }})
          }
        </span>
        </ng-template>
        <ng-template matTabContent>
          <app-nicht-freigegebene-antraege class="flex-container-column"
                                           [listData]="nichtFreigegebeneMaklerAntraegeDataSource"
                                           [filterChangedEvent]="filterChangedSubject.asObservable()">
          </app-nicht-freigegebene-antraege>
        </ng-template>
      </mat-tab>
    }
    <!-- / -->
    @if (userService.isAuthorized$(listDataConfig.LEBEN_AENDERUNGSOFFERT.right) | async) {
      <mat-tab [id]="ActiveTab.OfferteAntraege_Lebenaenderungsofferte">
        <ng-template mat-tab-label>
          <span>Änderungsanträge Leben</span>
          <span *ngIf="lebenAenderungsOfferteDataSource.loading" class="matTabRightText">
          <ng-container *ngTemplateOutlet="tabLabelSpinner"></ng-container>
        </span>
          <span *ngIf="!lebenAenderungsOfferteDataSource.loading"
                class="matTabRightText">({{ lebenAenderungsOfferteDataSource.dataSource.filteredData.length / 2 }}
            )</span>
        </ng-template>
        <ng-template matTabContent>
          <app-antraege [listData]="lebenAenderungsOfferteDataSource" class="flex-container-column"
                        [filterChangedEvent]="filterChangedSubject.asObservable()"
                        [markedPolintSubject]="markedPolintSubject" [isLebenAenderungsoffert]="true"></app-antraege>
        </ng-template>
      </mat-tab>
    }
    @if (userService.isAuthorized$(listDataConfig.VERDORBENER_ANTRAG.right) | async) {
      <mat-tab>
        <ng-template mat-tab-label>
          <span>Verdorbene Anträge</span>
          <span *ngIf="verdorbenerAntragDataSource.loading" class="matTabRightText">
          <ng-container *ngTemplateOutlet="tabLabelSpinner"></ng-container>
        </span>
          <span *ngIf="!verdorbenerAntragDataSource.loading" class="matTabRightText">
          ({{ verdorbenerAntragDataSource.dataSource.filteredData.length / 2 }})
        </span>
        </ng-template>
        <ng-template matTabContent>
          <app-verdorbene [listData]="verdorbenerAntragDataSource" class="flex-container-column"
                          [filterChangedEvent]="filterChangedSubject.asObservable()"
                          [markedPolintSubject]="markedPolintSubject"></app-verdorbene>
        </ng-template>
      </mat-tab>
    }
    @if (userService.isAuthorized$(listDataConfig.GENHEMIGUNG.right) | async) {
      <mat-tab [id]="ActiveTab.OfferteAntraege_GENEHMIGUNG">
        <ng-template mat-tab-label>
          <span>Genehmigungen</span>
          <span *ngIf="genehmigungDataSource.loading" class="matTabRightText">
          <ng-container *ngTemplateOutlet="tabLabelSpinner"></ng-container>
        </span>
          <span *ngIf="!genehmigungDataSource.loading" class="matTabRightText">
          ({{ genehmigungDataSource.dataSource.filteredData.length / 3 }})
        </span>
          <span *ngIf="!genehmigungDataSource.loading && countGehmigungDocsMissing() > 0"
                matBadge="{{countGehmigungDocsMissing()}}" class="matTabRightText">
          <mat-icon fontIcon="rule" class="mat-24" color="accent"></mat-icon>
        </span>
        </ng-template>
        <ng-template matTabContent>
          <app-genehmigungen [listData]="genehmigungDataSource" class="flex-container-column"
                             [filterChangedEvent]="filterChangedSubject.asObservable()"
                             [markedPolintSubject]="markedPolintSubject"
          ></app-genehmigungen>
        </ng-template>
      </mat-tab>
    }
    @if (userService.isAuthorized$(listDataConfig.VORL_DECKUNG.right) | async) {
      <mat-tab [id]="ActiveTab.OfferteAntraege_VORLDECKUNG">
        <ng-template mat-tab-label>
          <span>Vorläufige Deckungen</span>
          <span *ngIf="vorlDeckungDataSource.loading" class="matTabRightText">
          <ng-container *ngTemplateOutlet="tabLabelSpinner"></ng-container>
        </span>
          <span *ngIf="!vorlDeckungDataSource.loading" class="matTabRightText">
          ({{ vorlDeckungDataSource.dataSource.filteredData.length / 2 }})
        </span>
        </ng-template>
        <ng-template matTabContent>
          <app-vorlaufige-deckungen [listData]="vorlDeckungDataSource" class="flex-container-column"
                                    [filterChangedEvent]="filterChangedSubject.asObservable()"
                                    [markedPolintSubject]="markedPolintSubject"></app-vorlaufige-deckungen>
        </ng-template>
      </mat-tab>
    }
    <mat-tab>
      <ng-template mat-tab-label>
        <span>Schwebebestände</span>
        <span *ngIf="schwebeDataSource.loading" class="matTabRightText">
          <ng-container *ngTemplateOutlet="tabLabelSpinner"></ng-container>
        </span>
        <span *ngIf="!schwebeDataSource.loading" class="matTabRightText">
          ({{ schwebeDataSource.dataSource.filteredData.length / 2 }})
        </span>
      </ng-template>
      <ng-template matTabContent>
        <app-offerteantraege-schwebebestaende [listData]="schwebeDataSource" class="flex-container-column"
                                              [filterChangedEvent]="filterChangedSubject.asObservable()">
        </app-offerteantraege-schwebebestaende>
      </ng-template>
    </mat-tab>
    <!-- Anträge zur Prüfung (Maklerbetreuer) -->
    @if (userService.isAuthorized$(listDataConfig.OFFENE_MAKLER_ANTRAEGE.right) | async) {
      <mat-tab [id]="ActiveTab.OfferteAntraege_MaklerAntraegeZurPruefung">
        <ng-template mat-tab-label>
          <span>Anträge zur Prüfung</span>
          <span class="matTabRightText">
          @if (offeneMaklerAntraegeDataSource.loading) {
            <ng-container *ngTemplateOutlet="tabLabelSpinner"></ng-container>
          } @else {
            ({{ offeneMaklerAntraegeDataSource.dataSource.filteredData.length / 3 }})
          }
        </span>
        </ng-template>
        <ng-template matTabContent>
          <app-offerteantraege-offene-makler-antraege class="flex-container-column"
                                                      [listData]="offeneMaklerAntraegeDataSource"
                                                      [filterChangedEvent]="filterChangedSubject.asObservable()">
          </app-offerteantraege-offene-makler-antraege>
        </ng-template>
      </mat-tab>
      <mat-tab [id]="ActiveTab.OfferteAntraege_UnbetreuteMaklerAntraegeZurPruefung">
        <ng-template mat-tab-label>
          <span>Anträge unbetreutes Gebiet</span>
          <span class="matTabRightText">
          @if (offeneUnbetreuteMaklerAntraegeDataSource.loading) {
            <ng-container *ngTemplateOutlet="tabLabelSpinner"></ng-container>
          } @else {
            ({{ offeneUnbetreuteMaklerAntraegeDataSource.dataSource.filteredData.length / 3 }})
          }
        </span>
        </ng-template>
        <ng-template matTabContent>
          <app-offerteantraege-offene-makler-antraege class="flex-container-column"
                                                      [listData]="offeneUnbetreuteMaklerAntraegeDataSource"
                                                      [filterChangedEvent]="filterChangedSubject.asObservable()">
          </app-offerteantraege-offene-makler-antraege>
        </ng-template>
      </mat-tab>
    }
  </mat-tab-group>
</app-main-content>

<ng-template #tabLabelSpinner>
  <mat-spinner [diameter]="20" strokeWidth="1"></mat-spinner>
</ng-template>
